import axios from 'axios'
import i18n from './../plugins/i18n'

export default {
  getOffers(filters) {
    let filter = ''

    for (const field in filters) {
      filter += `${field}=${filters[field]}&`
    }

    return axios.get(`${i18n.locale}/api/public/cms/offers/?${filter}`)
  },

  getUserOffers(filters) {
    let filter = ''

    for (let field in filters) {
      filter += `${field}=${filters[field]}&`
    }

    return axios.get(`${i18n.locale}/api/offer/userOffers/?${filter}`)
  },

  getOffer(id) {
    return axios.get(`${i18n.locale}/api/public/cms/offer/${id}`)
  },

  createVote(id, type) {
    return axios
      .post(`${i18n.locale}/api/offer/createVote/${id}/${type}`)
  },

  createAppeal(id, data) {
    return axios
      .post(`${i18n.locale}/api/offer/createAppeal/${id}`, data)
  },

  createOffer(data) {
    return axios.post(`${i18n.locale}/api/offer/create`, data)
  },

  getOfferSearchFormData() {
    return axios.get(`${i18n.locale}/api/public/cms/offerSearchFormData`)
  },
}
